import { HistoryPayload } from 'data/types/history';
import { normalizeOrder } from 'model/orders';

export const normalizeHistory = (data: HistoryPayload) => ({
  orders: data.orders.map(normalizeOrder),
  previousPageId: data.previousPageId
    ? JSON.stringify(data.previousPageId)
    : undefined,
});

export type History = ReturnType<typeof normalizeHistory>;
